module.exports = __webpack_public_path__ + "img/icon-input-use.a7d782ba.svg";